export default __webpack_public_path__ + "static/media/balloons_responsive.93cba3a7.png";